<template>
    <div style="height: 100%;">
        <myself-course v-if="currentTab=='majorCourse'"></myself-course>
        <course-task v-else-if="currentTab=='courseTask'"></course-task>
    </div>
</template>

<script>
import MyselfCourse from '../personCenter/MyselfCourse.vue'
import CourseTask from './courseMag/CourseTask.vue'
    export default {
  components: { MyselfCourse, CourseTask },
  computed:{
        /**当前tab */
        currentTab(){
                return this.$store.state.backend.currentTab;
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>